/**
 * The one focus ring. Spread it after a component's own styles:
 *
 *   <a {...stylex.props(styles.link, focusRing)}>
 *
 * The ring shows on `:focus-visible` only, so a mouse click draws nothing and keyboard focus draws
 * the ring. `focusRingInset` draws it 2px inside the element, for list rows, table rows, menu
 * items and sidebar links, whose scrolling or clipped parent would cut off a ring drawn outside.
 *
 * The `styles/focus-ring` lint rule refuses `outline: "none"` in a style object that does not put
 * an outline back on `:focus-visible`.
 */
import * as stylex from "@stylexjs/stylex";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { border } from "@lattice/tokens/space.stylex";
const styles = {
  ring: {
    kjBf7l: "x1777dqa",
    kMeerF: "xzk9mvr",
    kInvED: "xvm977q",
    k3XXqK: "x1t137rt x9v5kkp",
    $$css: true
  },
  inset: {
    kjBf7l: "x1777dqa",
    kMeerF: "xzk9mvr",
    kInvED: "x1jb3n4g",
    k3XXqK: "x1t137rt x9v5kkp",
    $$css: true
  }
};
export const focusRing = styles.ring;
export const focusRingInset = styles.inset;